import { usePathname, useRouter } from 'next/navigation';
import { useScrollToElementId } from '@/hooks/useScrollTo.hook';
import { getMenuTopOffset } from '@/utils/headerOffset';

const MENU_MARGIN = 15;

export function usePaginationNavigation({
  scrollTargetElementId,
}: {
  scrollTargetElementId: string;
}) {
  const router = useRouter();
  const pathname = usePathname();
  const scrollToElementId = useScrollToElementId();

  const handlePageChange = (page: number) => {
    const params = new URLSearchParams();
    params.set('page', page.toString());

    router.push(`${pathname}?${params.toString()}`, {
      scroll: false,
    });
    const menuOffset = getMenuTopOffset();
    scrollToElementId(scrollTargetElementId, {
      offset: menuOffset + MENU_MARGIN,
      behavior: 'smooth',
    });
  };

  return { handlePageChange };
}
